// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
function decode(json, decoder) {
  var decoded = Curry._1(decoder, json);
  if (decoded.TAG === /* Ok */0) {
    return {
      TAG: /* Ok */0,
      _0: decoded._0
    };
  }
  var error = decoded._0;
  return {
    TAG: /* Error */1,
    _0: Belt_Array.keep([error.message, error.path], function (e) {
      return e.trim() !== "";
    }).join(" at ")
  };
}
export { decode };
/* No side effect */